import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const stateSlice = createSlice({
	name: 'notificationPanel/state',
	initialState: false,
	reducers: {
		toggleNotificationPanel: (state: any) => !state,
		openNotificationPanel: (state: any) => true,
		closeNotificationPanel: (state: any) => false
	}
});

export const { toggleNotificationPanel, openNotificationPanel, closeNotificationPanel } = stateSlice.actions;

export default stateSlice.reducer;
